// libs
import get from 'lodash/get';

// types
import { IWidgetInfo } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/types';

// constants
const ICONS_FOR_SECTIONS = {
  PD01: 'icon-box',
  KYP01: 'icon-information',
  VD01: 'icon-bn-account',
  REP01: 'icon-circle-exchange',
};

export const getTransformedInfo = (productInfo: IWidgetInfo[]) => {
  return productInfo.map((widget) => {
    const iconName = get(ICONS_FOR_SECTIONS, `${widget.widget_id}`, '');
    let widget_data = { ...widget };
    if (iconName != '') {
      widget_data = { ...widget_data, iconName: iconName };
    }
    if (widget.subtitle && widget.subtitle.length > 0) {
      const subtitle = widget.subtitle.join(', ');
      widget_data = { ...widget_data, subtitle };
    }
    return widget_data;
  });
};
